import { ChangeDetectionStrategy, Component, computed, inject, ViewEncapsulation } from "@angular/core";
import { LayoutWidget } from "../../layouts/se.layout.widget.abstract";
import { Layouts } from "../../layouts/se.layouts";
import { SeOrgDetailsStore } from "../se.org.details.store";
import { S25Util } from "../../../../util/s25-util";
import { SeSearchResultsComponent } from "../../search/tile.search.results.component";
import { convertSeEventToTileItem } from "../../search/tile.item.converters";

@Component({
    standalone: true,
    selector: "s25-ng-se-org-upcoming-events-widget",
    template: `
        @if (tileItems()?.length) {
            <s25-ng-se-search-results
                [results]="tileItems()"
                [resultsCount]="tileItems().length"
                [searchType]="'events'"
                [noResultsMessage]="''"
            />
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.Emulated,
    imports: [SeSearchResultsComponent],
})
export class SeOrgUpcomingEventsWidgetComponent extends LayoutWidget<typeof SeOrgUpcomingEventsWidgetComponent> {
    static readonly META = {
        name: "Upcoming Events",
        info: "Displays upcoming events for this organization.",
        settings: [{ id: "limit", label: "Max events", type: "field" as const, fieldType: "text" as const }],
        defaultSettings: {
            limit: "5",
        },
    } as const satisfies Layouts.WidgetStatic;

    protected readonly orgStore = inject(SeOrgDetailsStore);

    protected readonly limit = computed(() => S25Util.parseInt(this.settingValues()["limit"]) ?? 5);

    protected readonly tileItems = computed(() => {
        const events = this.orgStore.upcomingEvents() ?? [];
        const limit = this.limit();
        return events.slice(0, limit).map(convertSeEventToTileItem);
    });
}
